import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";

export interface ElementLibraryModalProps {
  elementTypeFilter?: string;
}

export interface SelectLibraryElementProps {
  elementId?: number;
}

export interface ElementLibraryModalState {
  isOpen: boolean;
  isSelected: boolean;
  isDeclined: boolean;
  elementTypeFilter?: string;
  selectedElementId: number;
}

const initialState: ElementLibraryModalState = {
  isOpen: false,
  isSelected: false,
  isDeclined: false,
  elementTypeFilter: "",
  selectedElementId: 0,
};

export const elementLibraryModalSlice = createSlice({
  name: "elementLibraryModal",
  initialState,
  reducers: {
    openElementLibraryModal: (
      state,
      action: PayloadAction<ElementLibraryModalProps>
    ) => {
      // Reset the chosen element
      state.selectedElementId = 0;

      if (action.payload.elementTypeFilter) {
        state.elementTypeFilter = action.payload.elementTypeFilter ?? "";
      }

      state.isOpen = true;
      state.isSelected = false;
      state.isDeclined = false;
    },
    closeElementLibraryModal: (state) => {
      state.selectedElementId = 0;

      state.elementTypeFilter = "";

      state.isOpen = false;
      state.isSelected = false;
      state.isDeclined = true;
    },
    selectLibraryElement: (
      state,
      action: PayloadAction<SelectLibraryElementProps>
    ) => {
      if (action.payload.elementId) {
        state.selectedElementId = action.payload.elementId;
      }
      state.isOpen = false;
      state.isSelected = true;
      state.isDeclined = false;
    },
  },
});

export const elementLibraryModalActions = elementLibraryModalSlice.actions;

export const selectElementLibraryModal = (state: RootState) =>
  state.elementLibraryModal;

export default elementLibraryModalSlice.reducer;
